module.exports = __webpack_public_path__ + "static/media/rsm-carpremium.70e0049c.svg";